import {
  obterTipoProgramaUsuarioLogado,
} from "./tipoPrograma.js";
import { obterTipoProgramaItem } from "../mappers/empresaMapper.js";
import {
  resolverChaveStatus,
  STATUS_PARA_ETAPA_SEM_ESTUDANTE,
  STATUS_PARA_ETAPA_COM_ESTUDANTE,
} from "../mappers/statusMapper.js";

export const etapasBasePorPrograma = {
  // 0 e 2: o estudante preenche DEPOIS do cadastro inicial e ANTES da validação
  0: [
    { id: 1, nome: "Cadastro inicial" },
    { id: 2, nome: "Aguardando Preenchimento do Estagiário" },
    { id: 3, nome: "Validação do preenchimento" },
    { id: 4, nome: "Aguardando assinatura" },
    { id: 5, nome: "Contrato finalizado" },
  ],
  2: [
    { id: 1, nome: "Cadastro inicial" },
    { id: 2, nome: "Aguardando Preenchimento do Aprendiz" },
    { id: 3, nome: "Validação do preenchimento" },
    { id: 4, nome: "Aguardando assinatura" },
    { id: 5, nome: "Contrato finalizado" },
  ],
  1: [
    { id: 1, nome: "Cadastro inicial" },
    { id: 2, nome: "Validação do preenchimento" },
    { id: 3, nome: "Aguardando assinatura" },
    { id: 4, nome: "Contrato finalizado" },
  ],
};

export const obterEtapasExemplo = (tipoPrograma = 1, temEstudante = false) => {
  const tp = Number(tipoPrograma);
  // TCA comum é só entre empresa e CIEE: nunca tem etapa do aprendiz.
  if (tp === 1) return etapasBasePorPrograma[1];
  if (temEstudante || tp === 0 || tp === 2) {
    return tp === 0 ? etapasBasePorPrograma[0] : etapasBasePorPrograma[2];
  }
  return etapasBasePorPrograma[1];
};

export const extrairIdItem = (it) => {
  if (!it) return "";
  const id =
    it.tce_id ??
    it.tca_empregador_id ??
    it.tca_id ??
    it.tcaId ??
    it.id ??
    it.autorizacao_id ??
    "";
  return String(id);
};

export const normalizarOrigemItem = (it) => {
  if (!it || typeof it !== "object") return "tca-empregador";
  const raw = it.raw || {};
  const orig = String(
    it._origem || raw._origem || it.origem || raw.origem || it.tipo_contrato || "",
  )
    .toLowerCase()
    .replace(/_/g, "-")
    .trim();

  if (orig === "tce" || orig === "estagio") return "tce";
  if (orig === "tca-empregador") return "tca-empregador";
  if (orig === "tca") return "tca";

  if (it.tce_id != null || raw.tce_id != null) return "tce";
  if (it.tca_empregador_id != null || raw.tca_empregador_id != null) {
    return "tca-empregador";
  }

  const tp = obterTipoProgramaItem(it);
  if (Number(tp) === 0) return "tce";
  if (Number(tp) === 1) return "tca";
  return "tca-empregador";
};

export const extrairChaveUnicaItem = (it) => {
  if (!it) return "";
  const id = extrairIdItem(it);
  if (!id) return "";
  return `${normalizarOrigemItem(it)}-${id}`;
};

export const mesmoItemAcompanhamento = (a, b) => {
  if (!a || !b) return false;
  if (a === b) return true;
  const chaveA = extrairChaveUnicaItem(a);
  const chaveB = extrairChaveUnicaItem(b);
  if (chaveA && chaveB) return chaveA === chaveB;
  const idA = extrairIdItem(a);
  const idB = extrairIdItem(b);
  return Boolean(idA && idB && idA === idB);
};

export const normalizarTextoBusca = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

export const resolverCnpjItem = (item) => {
  if (!item || typeof item !== "object") return "";
  const candidatos = [
    item.cnpj,
    item.cnpj_empresa,
    item?.raw?.cnpj,
    item?.raw?.cnpj_empresa,
    item?.raw?.empresa?.cnpj,
    item?.raw?.cadastro?.cnpj,
    item?.raw?.estudante?.cnpj,
    item.cnpj_ou_cpf,
    item.cnpj_cpf,
    item?.raw?.cnpj_ou_cpf,
    item?.raw?.cnpj_cpf,
    item?.documento,
  ];

  // Prioriza valor que seja estritamente um CNPJ (14 dígitos)
  for (const c of candidatos) {
    if (typeof c === "string") {
      const digitos = c.replace(/\D/g, "");
      if (digitos.length === 14) return c;
    }
  }

  // Fallback para o primeiro candidato não vazio
  for (const c of candidatos) {
    if (typeof c === "string" && c.trim()) return c;
  }
  return "";
};

export const resolverRazaoSocial = (item) => {
  if (!item || typeof item !== "object") return "";
  const nomeAprendiz =
    item?.estudante_nome ||
    item?.nome_estudante ||
    item?.nome_aprendiz ||
    item?.raw?.estudante_nome ||
    item?.raw?.nome_estudante ||
    item?.raw?.nome_aprendiz ||
    "";
  const nomeCandidato = item?.nome;
  const ehMesmoDoAprendiz =
    nomeCandidato && nomeAprendiz && nomeCandidato === nomeAprendiz;

  return (
    item.razao_social ||
    item.razaoSocial ||
    item.razaosocial ||
    item.empresa_nome ||
    item.nome_empresa ||
    item.nome_fantasia ||
    (typeof item.empresa === "string" ? item.empresa : "") ||
    (typeof item?.raw?.empresa === "string" ? item.raw.empresa : "") ||
    item?.raw?.razao_social ||
    item?.raw?.razaoSocial ||
    item?.raw?.razaosocial ||
    item?.raw?.empresa_nome ||
    item?.raw?.nome_empresa ||
    item?.raw?.empresa?.razao_social ||
    item?.raw?.empresa?.razaoSocial ||
    item?.raw?.empresa?.nome ||
    item?.raw?.cadastro?.razao_social ||
    item?.raw?.cadastro?.nome ||
    item?.empresa?.razao_social ||
    item?.empresa?.nome ||
    item?.cadastro?.razao_social ||
    (!ehMesmoDoAprendiz ? item?.nome : "") ||
    ""
  );
};

export const resolverNomeAprendiz = (item) => {
  if (!item || typeof item !== "object") return "";
  const raw = item.raw || {};
  const estudante = raw.estudante || item.estudante || {};
  const aprendiz = raw.aprendiz || item.aprendiz || {};
  const cadastro = raw.cadastro || item.cadastro || {};
  const aluno = raw.aluno || item.aluno || {};
  const usuario = raw.usuario || item.usuario || {};

  let candidato =
    item.nome_aprendiz ||
    item.nome_estudante ||
    item.estudante_nome ||
    item.aprendiz_nome ||
    item.nome_aluno ||
    item.aluno_nome ||
    raw.nome_aprendiz ||
    raw.nome_estudante ||
    raw.estudante_nome ||
    raw.aprendiz_nome ||
    raw.nome_aluno ||
    raw.aluno_nome ||
    aprendiz.nome ||
    aprendiz.nome_completo ||
    estudante.nome ||
    estudante.nome_completo ||
    aluno.nome ||
    aluno.nome_completo ||
    usuario.nome ||
    usuario.nome_completo ||
    cadastro.nome_aprendiz ||
    cadastro.nome_estudante ||
    cadastro.estudante_nome ||
    cadastro.aprendiz_nome ||
    cadastro.nome_aluno ||
    cadastro.aluno_nome ||
    cadastro.nome_completo ||
    cadastro.nome ||
    "";

  const razao = (resolverRazaoSocial(item) || "").trim().toLowerCase();

  if (!candidato) {
    const nomeTop = (item.nome_completo || raw.nome_completo || "").trim();
    if (nomeTop && (!razao || nomeTop.toLowerCase() !== razao)) {
      candidato = nomeTop;
    }
  }
  if (!candidato) {
    const nomeSimples = (item.nome || raw.nome || "").trim();
    if (nomeSimples && (!razao || nomeSimples.toLowerCase() !== razao)) {
      candidato = nomeSimples;
    }
  }

  if (candidato && razao && String(candidato).trim().toLowerCase() === razao) {
    return "";
  }
  return String(candidato || "").trim();
};

export const resolverCpfAprendiz = (item) => {
  if (!item || typeof item !== "object") return "";
  const raw = item.raw || {};
  const estudante = raw.estudante || item.estudante || {};
  const aprendiz = raw.aprendiz || item.aprendiz || {};
  const cadastro = raw.cadastro || item.cadastro || {};

  const candidatos = [
    item.cpf_aprendiz,
    item.cpf_estudante,
    item.estudante_cpf,
    item.aprendiz_cpf,
    item.cpf_aprendiz_menor_idade,
    raw.cpf_aprendiz,
    raw.cpf_estudante,
    raw.estudante_cpf,
    raw.aprendiz_cpf,
    raw.cpf_aprendiz_menor_idade,
    item.cpf,
    raw.cpf,
    aprendiz.cpf,
    estudante.cpf,
    cadastro.cpf_aprendiz,
    cadastro.cpf_estudante,
    cadastro.estudante_cpf,
    cadastro.cpf,
    item.documento,
    raw.documento,
  ];

  for (const c of candidatos) {
    if (!c) continue;
    const digitos = String(c).replace(/\D/g, "");
    if (digitos.length === 11) {
      return digitos;
    }
  }
  return "";
};

export const empresaMatches = (itemA, itemB) => {
  if (!itemA || !itemB) return false;
  if (itemA === itemB) return true;
  const idA = extrairIdItem(itemA);
  const idB = extrairIdItem(itemB);
  if (idA && idB && idA === idB) return true;

  // 1. Prioridade máxima: ID numérico da empresa (ex: 529801)
  const empIdA = itemA.empresa_id ?? itemA.id_empresa ?? itemA?.raw?.empresa_id;
  const empIdB = itemB.empresa_id ?? itemB.id_empresa ?? itemB?.raw?.empresa_id;
  if (
    empIdA != null &&
    empIdB != null &&
    String(empIdA) === String(empIdB) &&
    String(empIdA) !== "0" &&
    String(empIdA).trim() !== ""
  ) {
    return true;
  }

  // 2. Se ambos têm CNPJ válido de 14 dígitos, compara a raiz de 8 dígitos (mesma empresa ou filial)
  const cnpjA = resolverCnpjItem(itemA).replace(/\D/g, "");
  const cnpjB = resolverCnpjItem(itemB).replace(/\D/g, "");
  if (cnpjA.length === 14 && cnpjB.length === 14) {
    return cnpjA.slice(0, 8) === cnpjB.slice(0, 8);
  }

  // 3. Razão social
  const razaoA = (resolverRazaoSocial(itemA) || "").trim().toLowerCase();
  const razaoB = (resolverRazaoSocial(itemB) || "").trim().toLowerCase();
  if (razaoA && razaoB && razaoA === razaoB) return true;

  return false;
};

export const itemCorrespondeAoTermo = (item, termoBruto) => {
  if (!item) return false;
  const termoNormalizado = normalizarTextoBusca(termoBruto);
  if (!termoNormalizado) return true;

  const termoSemHash = termoNormalizado.replace(/^#/, "").trim();
  const termoDigitos = String(termoBruto).replace(/\D/g, "");

  // 1. Checagem direta de id (#86 ou 86)
  const idItem = extrairIdItem(item);
  if (termoSemHash && (idItem === termoSemHash || idItem.includes(termoSemHash))) {
    return true;
  }

  const raw = item.raw || {};
  const aprendiz = raw.aprendiz || item.aprendiz || {};
  const estudante = raw.estudante || item.estudante || {};
  const cadastro = raw.cadastro || item.cadastro || {};
  const aluno = raw.aluno || item.aluno || {};
  const usuario = raw.usuario || item.usuario || {};

  // 2. Checagem direta de digitos (CNPJ, CPF, Convenio, Codigo Empresa, IDs)
  if (termoDigitos.length >= 2) {
    const cnpjItem = resolverCnpjItem(item).replace(/\D/g, "");
    if (cnpjItem && cnpjItem.includes(termoDigitos)) return true;

    const cpfItem = resolverCpfAprendiz(item).replace(/\D/g, "");
    if (cpfItem && cpfItem.includes(termoDigitos)) return true;

    const docItem = String(item.documento || item.cnpj_ou_cpf || "").replace(/\D/g, "");
    if (docItem && docItem.includes(termoDigitos)) return true;

    const camposNumericos = [
      item.convenio,
      item.numero_convenio,
      item.num_convenio,
      item.codigo_convenio,
      raw.convenio,
      raw.numero_convenio,
      item.codigo_empresa,
      item.empresa_codigo,
      item.codigo_ciee,
      raw.codigo_empresa,
      raw.empresa_codigo,
      item.id_empresa,
      item.empresa_id,
      item.numero_termo,
      item.numero_termo_aditivo,
      raw.numero_termo,
    ]
      .filter(Boolean)
      .map((val) => String(val).replace(/\D/g, ""));

    if (camposNumericos.some((num) => num && num.includes(termoDigitos))) {
      return true;
    }
  }

  // 3. Checagem textual com normalizacao de acentos e divisao em palavras
  const tokens = termoNormalizado.split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;

  const camposTexto = [
    idItem,
    idItem ? `#${idItem}` : "",
    resolverNomeAprendiz(item),
    resolverRazaoSocial(item),
    resolverCnpjItem(item),
    resolverCpfAprendiz(item),
    item.nome_aprendiz,
    item.estudante_nome,
    item.aprendiz_nome,
    item.nome_estudante,
    item.nome_aluno,
    item.aluno_nome,
    item.nome,
    item.nome_completo,
    item.empresa_nome,
    item.nome_empresa,
    item.razao_social,
    item.nome_fantasia,
    item.status,
    item.status_label,
    item.label,
    raw.status,
    raw.status_label,
    raw.label,
    item.convenio,
    item.numero_convenio,
    raw.convenio,
    raw.numero_convenio,
    item.codigo_empresa,
    item.empresa_codigo,
    item.codigo_ciee,
    raw.codigo_empresa,
    aprendiz.nome,
    aprendiz.nome_completo,
    estudante.nome,
    estudante.nome_completo,
    aluno.nome,
    aluno.nome_completo,
    usuario.nome,
    usuario.nome_completo,
    cadastro.nome,
    cadastro.nome_completo,
    cadastro.razao_social,
    cadastro.empresa_nome,
    cadastro.nome_fantasia,
  ]
    .filter(Boolean)
    .map(normalizarTextoBusca);

  return tokens.every((token) => camposTexto.some((c) => c.includes(token)));
};

export const mesclarItemComStatusCompleto = (atual, itemOriginal, contexto) => {
  const payloadCru = contexto?.payload || {};
  const tipoLogado = Number(obterTipoProgramaUsuarioLogado());
  const isOrigemTce =
    atual?._origem === "tce" ||
    itemOriginal?._origem === "tce" ||
    atual?.raw?._origem === "tce" ||
    itemOriginal?.raw?._origem === "tce" ||
    atual?.tce_id != null ||
    itemOriginal?.tce_id != null ||
    tipoLogado === 0;

  const tipoOrig = (() => {
    if (isOrigemTce) {
      const ehExplicitamenteTca =
        (itemOriginal?._origem && itemOriginal._origem.includes("tca")) ||
        (atual?._origem && atual._origem.includes("tca"));
      if (!ehExplicitamenteTca) return 0;
    }

    const diretoOriginal =
      obterTipoProgramaItem(itemOriginal) ??
      obterTipoProgramaItem(atual) ??
      obterTipoProgramaItem(itemOriginal?.raw) ??
      obterTipoProgramaItem(atual?.raw);
    if (diretoOriginal !== null && diretoOriginal !== undefined) {
      return Number(diretoOriginal);
    }
    const candidatos = [
      itemOriginal?.tipo_programa,
      itemOriginal?.tipoPrograma,
      atual?.tipo_programa,
      atual?.tipoPrograma,
      itemOriginal?.raw?.tipo_programa,
      atual?.raw?.tipo_programa,
      payloadCru?.tipo_programa,
      tipoLogado,
    ];
    for (const c of candidatos) {
      const n = Number(c);
      if (Number.isFinite(n) && (n === 0 || n === 1 || n === 2)) return n;
    }
    return 2;
  })();

  const statusChave = resolverChaveStatus([
    payloadCru.status_label,
    payloadCru.label,
    itemOriginal?.status_label,
    itemOriginal?.label,
    atual?.status_label,
    atual?.label,
    payloadCru.status,
    payloadCru.status_canonico,
    itemOriginal?.status,
    itemOriginal?.raw?.status,
    atual?.status,
    atual?.raw?.status,
  ]);

  const statusStr = String(
    statusChave ||
    payloadCru.status ||
    itemOriginal?.status ||
    atual?.status ||
    payloadCru.status_label ||
    itemOriginal?.status_label ||
    atual?.status_label ||
    ""
  ).toUpperCase();

  const ehStatusAprendizOuEstudante =
    statusStr.includes("APRENDIZ") ||
    statusStr.includes("ESTUDANTE") ||
    statusStr.includes("EM_PREENCHIMENTO");

  const totalRaw = Number(
    payloadCru.total_etapas ||
    atual?.total_etapas ||
    itemOriginal?.total_etapas
  );

  const ehCincoEtapas =
    tipoOrig === 0 ||
    tipoOrig === 2 ||
    (tipoOrig !== 1 && (totalRaw === 5 || ehStatusAprendizOuEstudante));

  const isTca1 = tipoOrig === 1 && !ehCincoEtapas;

  let etapaFinal = null;
  let totalEtapasFinal = isTca1 ? 4 : 5;
  let labelFinal = payloadCru.label || atual?.label || itemOriginal?.label;
  let statusLabelFinal =
    payloadCru.status_label || atual?.status_label || itemOriginal?.status_label;
  let corFinal = payloadCru.cor || atual?.cor || itemOriginal?.cor;

  if (isTca1) {
    totalEtapasFinal = 4;
    if (STATUS_PARA_ETAPA_SEM_ESTUDANTE[statusChave]) {
      etapaFinal = STATUS_PARA_ETAPA_SEM_ESTUDANTE[statusChave];
    } else {
      const etapaRaw = Number(
        payloadCru.etapa_atual ??
        atual?.etapa_atual ??
        itemOriginal?.etapa_atual ??
        2,
      );
      const totalBackend = Number(
        payloadCru.total_etapas ??
        atual?.total_etapas ??
        itemOriginal?.total_etapas ??
        4,
      );
      if (totalBackend === 5) {
        if (etapaRaw <= 1) etapaFinal = 1;
        else if (etapaRaw === 2 || etapaRaw === 3) etapaFinal = 2;
        else if (etapaRaw === 4) etapaFinal = 3;
        else etapaFinal = 4;
      } else {
        etapaFinal = Math.min(Math.max(1, etapaRaw || 2), 4);
      }
    }

    if (statusChave === "AGUARDANDO_ASSINATURAS" || etapaFinal === 3) {
      labelFinal = "Aguardando assinatura";
      statusLabelFinal = "Aguardando assinaturas";
      corFinal = "#1e3a8a";
    } else if (statusChave === "FINALIZADO" || etapaFinal === 4) {
      labelFinal = "Contrato finalizado";
      statusLabelFinal = "Finalizado";
      corFinal = "#134b8b";
    } else if (
      !labelFinal ||
      /aprendiz|estudante/i.test(labelFinal || "") ||
      /aprendiz|estudante/i.test(statusLabelFinal || "")
    ) {
      labelFinal = "Validação do preenchimento";
      statusLabelFinal = "Aguardando validação do CIEEMG";
      corFinal = "#3b82f6";
    }
  } else {
    const mapaEtapa = STATUS_PARA_ETAPA_COM_ESTUDANTE;
    const etapaMinimaPorStatus = mapaEtapa[statusChave] || 1;

    const etapaJaVista = Number(
      atual?.etapa_atual ?? atual?.raw?.etapa_atual ?? 0,
    );
    const etapaNova = Number(payloadCru.etapa_atual ?? 0);
    etapaFinal = Math.max(etapaNova, etapaJaVista, etapaMinimaPorStatus);
    etapaFinal = Math.min(Math.max(1, etapaFinal), 5);

    if (tipoOrig === 0) {
      if (
        statusChave === "AGUARDANDO_ESTUDANTE" ||
        statusChave === "AGUARDANDO_APRENDIZ" ||
        statusChave === "EM_PREENCHIMENTO" ||
        /aprendiz|estudante/i.test(labelFinal || "") ||
        /aprendiz|estudante/i.test(statusLabelFinal || "")
      ) {
        labelFinal = "Aguardando Preenchimento do Estagiário";
        statusLabelFinal = "Aguardando Preenchimento do Estagiário";
      } else if (statusChave === "REPROVADO_ESTUDANTE") {
        labelFinal = "Reprovado — voltar p/ Estagiário";
        statusLabelFinal = "Reprovado — voltar p/ Estagiário";
      }
    } else {
      if (
        statusChave === "AGUARDANDO_ESTUDANTE" ||
        statusChave === "AGUARDANDO_APRENDIZ" ||
        statusChave === "EM_PREENCHIMENTO" ||
        /estudante/i.test(labelFinal || "") ||
        /estudante/i.test(statusLabelFinal || "") ||
        /aprendiz/i.test(labelFinal || "") ||
        /aprendiz/i.test(statusLabelFinal || "") ||
        ehStatusAprendizOuEstudante
      ) {
        if (
          statusChave === "AGUARDANDO_ESTUDANTE" ||
          statusChave === "AGUARDANDO_APRENDIZ" ||
          statusChave === "EM_PREENCHIMENTO"
        ) {
          labelFinal = "Aguardando Preenchimento do Aprendiz";
          statusLabelFinal = "Aguardando Preenchimento do Aprendiz";
        }
      } else if (statusChave === "REPROVADO_ESTUDANTE") {
        labelFinal = "Reprovado — voltar p/ Aprendiz";
        statusLabelFinal = "Reprovado — voltar p/ Aprendiz";
      }
    }
  }

  const camposDerivados = {
    tipo_programa: isTca1 ? 1 : (payloadCru.tipo_programa ?? tipoOrig),
    status: payloadCru.status ?? itemOriginal?.status ?? atual?.status,
    etapa_atual: etapaFinal ?? payloadCru.etapa_atual,
    total_etapas: totalEtapasFinal,
    label: labelFinal,
    cor: corFinal,
    status_label: statusLabelFinal,
    rejeitado: payloadCru.rejeitado,
    finalizado: payloadCru.finalizado,
    supex: payloadCru.supex,
    ultimo_evento: payloadCru.ultimo_evento,
    historico: payloadCru.historico,
  };
  // Protege campos de identidade consolidados do item contra sobrescrita por /status-completo
  const razaoOrig =
    atual?.razao_social ||
    itemOriginal?.razao_social ||
    atual?.empresa?.razao_social ||
    itemOriginal?.empresa?.razao_social ||
    atual?.raw?.razao_social ||
    itemOriginal?.raw?.razao_social;
  const cnpjOrig =
    atual?.cnpj ||
    itemOriginal?.cnpj ||
    atual?.empresa?.cnpj ||
    itemOriginal?.empresa?.cnpj ||
    atual?.raw?.cnpj ||
    itemOriginal?.raw?.cnpj;
  const nomeCompletoOrig =
    atual?.nome_completo ||
    itemOriginal?.nome_completo ||
    atual?.nome_aprendiz ||
    itemOriginal?.nome_aprendiz ||
    atual?.raw?.nome_completo ||
    itemOriginal?.raw?.nome_completo;
  const nomeAprendizOrig =
    atual?.nome_aprendiz ||
    itemOriginal?.nome_aprendiz ||
    atual?.raw?.nome_aprendiz ||
    itemOriginal?.raw?.nome_aprendiz;
  const cpfAprendizOrig =
    atual?.cpf_aprendiz ||
    itemOriginal?.cpf_aprendiz ||
    atual?.raw?.cpf_aprendiz ||
    itemOriginal?.raw?.cpf_aprendiz;

  const rawAtualizado = payloadCru
    ? {
        ...(atual?.raw || {}),
        ...payloadCru,
        ...camposDerivados,
        ...(razaoOrig ? { razao_social: razaoOrig } : {}),
        ...(cnpjOrig ? { cnpj: cnpjOrig } : {}),
        ...(nomeCompletoOrig ? { nome_completo: nomeCompletoOrig } : {}),
        ...(nomeAprendizOrig ? { nome_aprendiz: nomeAprendizOrig } : {}),
        ...(cpfAprendizOrig ? { cpf_aprendiz: cpfAprendizOrig } : {}),
      }
    : atual?.raw;
  if (isTca1 && rawAtualizado) {
    rawAtualizado.tipo_programa = 1;
    rawAtualizado.total_etapas = 4;
    rawAtualizado.etapa_atual = etapaFinal;
  }
  return {
    ...atual,
    ...camposDerivados,
    ...(razaoOrig ? { razao_social: razaoOrig } : {}),
    ...(cnpjOrig ? { cnpj: cnpjOrig } : {}),
    ...(nomeCompletoOrig ? { nome_completo: nomeCompletoOrig } : {}),
    ...(nomeAprendizOrig ? { nome_aprendiz: nomeAprendizOrig } : {}),
    ...(cpfAprendizOrig ? { cpf_aprendiz: cpfAprendizOrig } : {}),
    tipo_programa: isTca1 ? 1 : (atual?.tipo_programa ?? tipoOrig),
    raw: rawAtualizado,
  };
};

/**
 * Valida se um item pertence de forma estrita ao programa ativo/desejado:
 *   - 0: Estágio (TCE)
 *   - 1: Aprendizagem Empresa Empregadora (TCA tipo 1)
 *   - 2: Aprendizagem CIEEMG Empregador (TCA tipo 2)
 */
export const itemPertenceAoPrograma = (item, tipoDesejado) => {
  if (!item) return false;
  const tipoNum = Number(tipoDesejado);
  if (!Number.isFinite(tipoNum) || (tipoNum !== 0 && tipoNum !== 1 && tipoNum !== 2)) {
    return true;
  }

  const raw = item.raw || {};
  const origem = String(
    item._origem || item.origem || raw._origem || raw.origem || item.tipo_contrato || ""
  ).toLowerCase();

  const tpItem = (() => {
    const candidatos = [
      item.tipo_programa,
      item.tipoPrograma,
      raw.tipo_programa,
      raw.tipoPrograma,
      item.cadastro?.tipo_programa,
    ];
    for (const c of candidatos) {
      const n = Number(c);
      if (Number.isInteger(n) && (n === 0 || n === 1 || n === 2)) return n;
    }
    return null;
  })();

  const ehOrigemTce = origem === "tce" || origem === "estagio";
  const ehOrigemTcaEmp =
    origem.includes("tca-empregador") || origem.includes("tca_empregador");
  const ehOrigemTca1 = origem === "tca";

  const temTceId = item.tce_id != null || raw.tce_id != null || item.id_tce != null;
  const temTcaEmpId =
    item.tca_empregador_id != null ||
    raw.tca_empregador_id != null ||
    item.id_tca_empregador != null;
  const temTcaId = !ehOrigemTce && (item.tca_id != null || raw.tca_id != null || item.id_tca != null);

  const temCamposAprendiz = Boolean(
    item.cpf_aprendiz ||
    item.nome_aprendiz ||
    raw.cpf_aprendiz ||
    raw.nome_aprendiz
  );

  const temCamposEstagiario = Boolean(
    item.cpf_estagiario ||
    item.nome_estagiario ||
    item.cargo_estagiario ||
    item.cpf_estudante_estagiario ||
    item.inicio_estagio ||
    item.nome_completo ||
    item.estudante_nome ||
    item.seguradora ||
    item.apolice_seguro ||
    raw.cpf_estagiario ||
    raw.nome_estagiario ||
    raw.cargo_estagiario ||
    raw.cpf_estudante_estagiario ||
    raw.inicio_estagio ||
    raw.nome_completo ||
    raw.estudante_nome ||
    raw.seguradora ||
    raw.apolice_seguro
  );

  if (tipoNum === 0) {
    if (tpItem === 1 || tpItem === 2) return false;
    if (ehOrigemTcaEmp || ehOrigemTca1) return false;
    if (temTcaEmpId || (!ehOrigemTce && temTcaId)) return false;
    if (temCamposAprendiz && !temCamposEstagiario && !temTceId) return false;
    return (
      ehOrigemTce ||
      temTceId ||
      tpItem === 0 ||
      (temCamposEstagiario && !temCamposAprendiz)
    );
  }

  if (tipoNum === 1) {
    if (tpItem === 0 || tpItem === 2) return false;
    if (ehOrigemTce || ehOrigemTcaEmp) return false;
    if (temTceId || temTcaEmpId) return false;
    if (temCamposEstagiario && !temCamposAprendiz && !temTcaId) return false;
    return ehOrigemTca1 || temTcaId || tpItem === 1;
  }

  if (tipoNum === 2) {
    if (tpItem === 0 || tpItem === 1) return false;
    if (ehOrigemTce || ehOrigemTca1) return false;
    if (temTceId) return false;
    if (temCamposEstagiario && !temCamposAprendiz && !temTcaEmpId) return false;
    return ehOrigemTcaEmp || temTcaEmpId || tpItem === 2;
  }

  return true;
};

